// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"95":"frontend/css/app","196":"assets/css/app"}[chunkId] + ".css";
};